// Script variable and function tables (RSDKv4 revision 3 numbering), generated from the decompilation.

export const VARIABLE_NAMES = [
  "temp0",
  "temp1",
  "temp2",
  "temp3",
  "temp4",
  "temp5",
  "temp6",
  "temp7",
  "checkResult",
  "arrayPos0",
  "arrayPos1",
  "arrayPos2",
  "arrayPos3",
  "arrayPos4",
  "arrayPos5",
  "arrayPos6",
  "arrayPos7",
  "global",
  "local",
  "object.entityPos",
  "object.groupID",
  "object.type",
  "object.propertyValue",
  "object.xpos",
  "object.ypos",
  "object.ixpos",
  "object.iypos",
  "object.xvel",
  "object.yvel",
  "object.speed",
  "object.state",
  "object.rotation",
  "object.scale",
  "object.priority",
  "object.drawOrder",
  "object.direction",
  "object.inkEffect",
  "object.alpha",
  "object.frame",
  "object.animation",
  "object.prevAnimation",
  "object.animationSpeed",
  "object.animationTimer",
  "object.angle",
  "object.lookPosX",
  "object.lookPosY",
  "object.collisionMode",
  "object.collisionPlane",
  "object.controlMode",
  "object.controlLock",
  "object.pushing",
  "object.visible",
  "object.tileCollisions",
  "object.interaction",
  "object.gravity",
  "object.up",
  "object.down",
  "object.left",
  "object.right",
  "object.jumpPress",
  "object.jumpHold",
  "object.scrollTracking",
  "object.floorSensorL",
  "object.floorSensorC",
  "object.floorSensorR",
  "object.floorSensorLC",
  "object.floorSensorRC",
  "object.collisionLeft",
  "object.collisionTop",
  "object.collisionRight",
  "object.collisionBottom",
  "object.outOfBounds",
  "object.spriteSheet",
  "object.value0",
  "object.value1",
  "object.value2",
  "object.value3",
  "object.value4",
  "object.value5",
  "object.value6",
  "object.value7",
  "object.value8",
  "object.value9",
  "object.value10",
  "object.value11",
  "object.value12",
  "object.value13",
  "object.value14",
  "object.value15",
  "object.value16",
  "object.value17",
  "object.value18",
  "object.value19",
  "object.value20",
  "object.value21",
  "object.value22",
  "object.value23",
  "object.value24",
  "object.value25",
  "object.value26",
  "object.value27",
  "object.value28",
  "object.value29",
  "object.value30",
  "object.value31",
  "object.value32",
  "object.value33",
  "object.value34",
  "object.value35",
  "object.value36",
  "object.value37",
  "object.value38",
  "object.value39",
  "object.value40",
  "object.value41",
  "object.value42",
  "object.value43",
  "object.value44",
  "object.value45",
  "object.value46",
  "object.value47",
  "stage.state",
  "stage.activeList",
  "stage.listPos",
  "stage.timeEnabled",
  "stage.milliSeconds",
  "stage.seconds",
  "stage.minutes",
  "stage.actNum",
  "stage.pauseEnabled",
  "stage.listSize",
  "stage.newXBoundary1",
  "stage.newXBoundary2",
  "stage.newYBoundary1",
  "stage.newYBoundary2",
  "stage.curXBoundary1",
  "stage.curXBoundary2",
  "stage.curYBoundary1",
  "stage.curYBoundary2",
  "stage.deformationData0",
  "stage.deformationData1",
  "stage.deformationData2",
  "stage.deformationData3",
  "stage.waterLevel",
  "stage.activeLayer",
  "stage.midPoint",
  "stage.playerListPos",
  "stage.debugMode",
  "stage.entityPos",
  "screen.cameraEnabled",
  "screen.cameraTarget",
  "screen.cameraStyle",
  "screen.cameraX",
  "screen.cameraY",
  "screen.drawListSize",
  "screen.xcenter",
  "screen.ycenter",
  "screen.xsize",
  "screen.ysize",
  "screen.xoffset",
  "screen.yoffset",
  "screen.shakeX",
  "screen.shakeY",
  "screen.adjustCameraY",
  "touchscreen.down",
  "touchscreen.xpos",
  "touchscreen.ypos",
  "music.volume",
  "music.currentTrack",
  "music.position",
  "keyDown.up",
  "keyDown.down",
  "keyDown.left",
  "keyDown.right",
  "keyDown.buttonA",
  "keyDown.buttonB",
  "keyDown.buttonC",
  "keyDown.buttonX",
  "keyDown.buttonY",
  "keyDown.buttonZ",
  "keyDown.buttonL",
  "keyDown.buttonR",
  "keyDown.start",
  "keyDown.select",
  "keyPress.up",
  "keyPress.down",
  "keyPress.left",
  "keyPress.right",
  "keyPress.buttonA",
  "keyPress.buttonB",
  "keyPress.buttonC",
  "keyPress.buttonX",
  "keyPress.buttonY",
  "keyPress.buttonZ",
  "keyPress.buttonL",
  "keyPress.buttonR",
  "keyPress.start",
  "keyPress.select",
  "menu1.selection",
  "menu2.selection",
  "tileLayer.xsize",
  "tileLayer.ysize",
  "tileLayer.type",
  "tileLayer.angle",
  "tileLayer.xpos",
  "tileLayer.ypos",
  "tileLayer.zpos",
  "tileLayer.parallaxFactor",
  "tileLayer.scrollSpeed",
  "tileLayer.scrollPos",
  "tileLayer.deformationOffset",
  "tileLayer.deformationOffsetW",
  "hParallax.parallaxFactor",
  "hParallax.scrollSpeed",
  "hParallax.scrollPos",
  "vParallax.parallaxFactor",
  "vParallax.scrollSpeed",
  "vParallax.scrollPos",
  "scene3D.vertexCount",
  "scene3D.faceCount",
  "scene3D.projectionX",
  "scene3D.projectionY",
  "scene3D.fogColor",
  "scene3D.fogStrength",
  "vertexBuffer.x",
  "vertexBuffer.y",
  "vertexBuffer.z",
  "vertexBuffer.u",
  "vertexBuffer.v",
  "faceBuffer.a",
  "faceBuffer.b",
  "faceBuffer.c",
  "faceBuffer.d",
  "faceBuffer.flag",
  "faceBuffer.color",
  "saveRAM",
  "engine.state",
  "engine.language",
  "engine.onlineActive",
  "engine.sfxVolume",
  "engine.bgmVolume",
  "engine.trialMode",
  "engine.deviceType",
  "screen.currentID",
  "camera.enabled",
  "camera.target",
  "camera.style",
  "camera.xpos",
  "camera.ypos",
  "camera.adjustY",
  "engine.hapticsEnabled",
  // Sonic Coop additions (appended so every original id is unchanged)
  "camera.curXBoundary1",
  "camera.curXBoundary2",
  "camera.curYBoundary1",
  "camera.curYBoundary2",
  "camera.xoffset",
  "camera.yoffset",
  "engine.playerCount",
] as const;

export const FUNCTIONS: [string, number][] = [
  ["End", 0],
  ["Equal", 2],
  ["Add", 2],
  ["Sub", 2],
  ["Inc", 1],
  ["Dec", 1],
  ["Mul", 2],
  ["Div", 2],
  ["ShR", 2],
  ["ShL", 2],
  ["And", 2],
  ["Or", 2],
  ["Xor", 2],
  ["Mod", 2],
  ["FlipSign", 1],
  ["CheckEqual", 2],
  ["CheckGreater", 2],
  ["CheckLower", 2],
  ["CheckNotEqual", 2],
  ["IfEqual", 3],
  ["IfGreater", 3],
  ["IfGreaterOrEqual", 3],
  ["IfLower", 3],
  ["IfLowerOrEqual", 3],
  ["IfNotEqual", 3],
  ["else", 0],
  ["endif", 0],
  ["WEqual", 3],
  ["WGreater", 3],
  ["WGreaterOrEqual", 3],
  ["WLower", 3],
  ["WLowerOrEqual", 3],
  ["WNotEqual", 3],
  ["loop", 0],
  ["ForEachActive", 3],
  ["ForEachAll", 3],
  ["next", 0],
  ["switch", 2],
  ["break", 0],
  ["endswitch", 0],
  ["Rand", 2],
  ["Sin", 2],
  ["Cos", 2],
  ["Sin256", 2],
  ["Cos256", 2],
  ["ATan2", 3],
  ["Interpolate", 4],
  ["InterpolateXY", 7],
  ["LoadSpriteSheet", 1],
  ["RemoveSpriteSheet", 1],
  ["DrawSprite", 1],
  ["DrawSpriteXY", 3],
  ["DrawSpriteScreenXY", 3],
  ["DrawTintRect", 4],
  ["DrawNumbers", 7],
  ["DrawActName", 7],
  ["DrawMenu", 3],
  ["SpriteFrame", 6],
  ["EditFrame", 7],
  ["LoadPalette", 5],
  ["RotatePalette", 4],
  ["SetScreenFade", 4],
  ["SetActivePalette", 3],
  ["SetPaletteFade", 6],
  ["SetPaletteEntry", 3],
  ["GetPaletteEntry", 3],
  ["CopyPalette", 5],
  ["ClearScreen", 1],
  ["DrawSpriteFX", 4],
  ["DrawSpriteScreenFX", 4],
  ["LoadAnimation", 1],
  ["SetupMenu", 4],
  ["AddMenuEntry", 3],
  ["EditMenuEntry", 4],
  ["LoadStage", 0],
  ["DrawRect", 8],
  ["ResetObjectEntity", 5],
  ["BoxCollisionTest", 11],
  ["CreateTempObject", 4],
  ["ProcessObjectMovement", 0],
  ["ProcessObjectControl", 0],
  ["ProcessAnimation", 0],
  ["DrawObjectAnimation", 0],
  ["SetMusicTrack", 3],
  ["PlayMusic", 1],
  ["StopMusic", 0],
  ["PauseMusic", 0],
  ["ResumeMusic", 0],
  ["SwapMusicTrack", 4],
  ["PlaySfx", 2],
  ["StopSfx", 1],
  ["SetSfxAttributes", 3],
  ["ObjectTileCollision", 4],
  ["ObjectTileGrip", 4],
  ["Not", 1],
  ["Draw3DScene", 0],
  ["SetIdentityMatrix", 1],
  ["MatrixMultiply", 2],
  ["MatrixTranslateXYZ", 4],
  ["MatrixScaleXYZ", 4],
  ["MatrixRotateX", 2],
  ["MatrixRotateY", 2],
  ["MatrixRotateZ", 2],
  ["MatrixRotateXYZ", 4],
  ["MatrixInverse", 1],
  ["TransformVertices", 3],
  ["CallFunction", 1],
  ["return", 0],
  ["SetLayerDeformation", 6],
  ["CheckTouchRect", 4],
  ["GetTileLayerEntry", 4],
  ["SetTileLayerEntry", 4],
  ["GetBit", 3],
  ["SetBit", 3],
  ["ClearDrawList", 1],
  ["AddDrawListEntityRef", 2],
  ["GetDrawListEntityRef", 3],
  ["SetDrawListEntityRef", 3],
  ["Get16x16TileInfo", 4],
  ["Set16x16TileInfo", 4],
  ["Copy16x16Tile", 2],
  ["GetAnimationByName", 2],
  ["ReadSaveRAM", 0],
  ["WriteSaveRAM", 0],
  ["LoadTextFile", 2],
  ["GetTextInfo", 5],
  ["GetVersionNumber", 2],
  ["GetTableValue", 3],
  ["SetTableValue", 3],
  ["CheckCurrentStageFolder", 1],
  ["Abs", 1],
  ["CallNativeFunction", 1],
  ["CallNativeFunction2", 3],
  ["CallNativeFunction4", 5],
  ["SetObjectRange", 1],
  ["GetObjectValue", 3],
  ["SetObjectValue", 3],
  ["CopyObject", 3],
  ["Print", 3],
  ["CheckCameraProximity", 4],
  ["SetScreenCount", 1],
  ["SetScreenVertices", 5],
  ["GetInputDeviceID", 2],
  ["GetFilteredInputDeviceID", 4],
  ["GetInputDeviceType", 2],
  ["IsInputDeviceAssigned", 1],
  ["AssignInputSlotToDevice", 2],
  ["IsInputSlotAssigned", 1],
  ["ResetInputSlotAssignments", 0],
];

export const BUILTIN_ALIASES: [string, string][] = [
  ["true", "1"],
  ["false", "0"],
  ["FX_SCALE", "0"],
  ["FX_ROTATE", "1"],
  ["FX_ROTOZOOM", "2"],
  ["FX_INK", "3"],
  ["PRESENTATION_STAGE", "0"],
  ["REGULAR_STAGE", "1"],
  ["BONUS_STAGE", "2"],
  ["SPECIAL_STAGE", "3"],
  ["MENU_1", "0"],
  ["MENU_2", "1"],
  ["C_TOUCH", "0"],
  ["C_SOLID", "1"],
  ["C_SOLID2", "2"],
  ["C_PLATFORM", "3"],
  ["C_BOX", "65536"],
  ["MAT_WORLD", "0"],
  ["MAT_VIEW", "1"],
  ["MAT_TEMP", "2"],
  ["FX_FLIP", "5"],
  ["FACING_LEFT", "1"],
  ["FACING_RIGHT", "0"],
  ["STAGE_2P_MODE", "4"],
  ["STAGE_FROZEN", "3"],
  ["STAGE_PAUSED", "2"],
  ["STAGE_RUNNING", "1"],
  ["RESET_GAME", "2"],
  ["STANDARD", "0"],
  ["MOBILE", "1"],
  ["DEVICE_XBOX", "2"],
  ["DEVICE_PSN", "3"],
  ["DEVICE_IOS", "4"],
  ["DEVICE_ANDROID", "5"],
];

export const V: Record<string, number> = {};
VARIABLE_NAMES.forEach((n, i) => (V[n] = i));
export const FN: Record<string, number> = {};
FUNCTIONS.forEach(([n], i) => (FN[n] = i));
